import { render, staticRenderFns } from "./formulario_campo_paragrafo.vue?vue&type=template&id=2f1d31a8&scoped=true&"
import script from "./formulario_campo_paragrafo.vue?vue&type=script&lang=js&"
export * from "./formulario_campo_paragrafo.vue?vue&type=script&lang=js&"
import style0 from "./formulario_campo_paragrafo.vue?vue&type=style&index=0&id=2f1d31a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1d31a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VSwitch,VTextField,VTextarea})
